import { getCookie, setCookie } from './cookie'

const VISIT_COOKIE = '_dd_visit'

// localDateKey 返回本地时区 YYYY-MM-DD(仅作每日自闸节流,精确性不敏感)。
function localDateKey(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

// fireVisitBeacon 每浏览器每天最多发一次 POST /gapi/public/visit(fire-and-forget)。
// cookie _dd_visit=今日 自闸;带 credentials 让后端读 _dd_agent 归因。SSR/无 document 安全跳过。
export function fireVisitBeacon(now: Date = new Date()): void {
  if (typeof document === 'undefined' || typeof fetch === 'undefined') return
  const today = localDateKey(now)
  if (getCookie(VISIT_COOKIE) === today) return
  setCookie(VISIT_COOKIE, today, 1) // ~1 天后过期,次日再发
  try {
    void fetch('/gapi/public/visit', { method: 'POST', credentials: 'include', keepalive: true }).catch(() => {})
  } catch {
    /* fire-and-forget,忽略 */
  }
}
